module.exports = __webpack_public_path__ + "img/belem-bus-tour.9733e3e7.jpg";